const SDK_VERSION = '7.35.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
